import * as React from 'react';
import styled from 'styled-components';
import { verticalSpace } from '@doltech/utils/lib/css-style';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { LineDivider } from '@doltech/ui/lib/figma/Divider/LineDivider';
import {
  ViewMultiStudents,
} from './ViewMultiStudents';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { isEmpty } from 'lodash';

const Container = styled.aside`
  display: grid;
  grid-template-columns: minmax(0, 320px);
  margin-right: 24px;
  column-gap: 20px;

  .sign-in {
    color: ${colorsV2.purple100};

    &:hover {
      color: ${colorsV2.purple80};
      cursor: pointer;
    }
  }
`;

const TopWrapper = styled.div`
  ${verticalSpace(16)};
`;

interface SideInfoReadingInfoNotAuthProps {
  title?: string;
  users?: any[];
  onSignUp?: () => void;
}

export const SideInfoReadingInfoNotAuth = (props: SideInfoReadingInfoNotAuthProps) => {
  const { title, users, onSignUp } = props;

  return (
    <Container>
      <TopWrapper>
        <ResponsiveTypography.Paragraph variant="semi-bold/16-28" color="gray180" ellipsis={{ tooltip: true }}>
          {title}
        </ResponsiveTypography.Paragraph>
        {!isEmpty(users) &&
          <ViewMultiStudents
            users={users}
            maxCount={8}
          />
        }
      </TopWrapper>
      <LineDivider/>
      <ResponsiveTypography.Paragraph variant="regular/16-24" color="gray180">
        <ResponsiveTypography.Text className="sign-in" variant="Medium/16px | 24px" onClick={onSignUp}>
          Đăng nhập {' '}
        </ResponsiveTypography.Text>
        để lưu lại quá trình học và làm bài của bạn nhé!
      </ResponsiveTypography.Paragraph>
    </Container>
  );
};
